import { render, staticRenderFns } from "./ViewFeedbackModal.vue?vue&type=template&id=ba679f8c"
import script from "./ViewFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./ViewFeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./ViewFeedbackModal.vue?vue&type=style&index=0&id=ba679f8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports